import React, { Component, PropTypes } from 'react';
import { Modal,Upload,Row,Col,Icon,Button,message,Table,Spin  } from 'antd';
import {baseUrl} from '../../../../utils/NHPrefixUrl';

const pathUrl = baseUrl;

export default class Import extends Component{
    static defaultProps = {
        title:'上传文件',
        onOk:(resultList)=>{
            //处理后的数据
        },
        width:1150,
        height:600,
        maskClosable:false,//点击蒙层是否允许关闭,默认值为true
        closable:true,//是否显示右上角的关闭,默认值为true
        templateUrl:undefined,//导入模板下载路径
        tempStr:'离校业务项办理导入模板.xls',//模板文件
        data:{},//表头转换数据 {姓名:'xm',学号:'xh'}
        // key:'wydjkyl'//当想要重新加载一个新的选择器，可以使用
    };
    constructor(props){
        super(props);
        this.state={
            visible:false,
            okText:'保存',
            cancelText:'取消',
            fileList:[],
            resultObj:undefined,
            loading:false,
        }
    }
    show = ()=>{
        this.setState({
            visible:true,
            fileList:[],
            okText:'保存',
        });
    }
    close = ()=>{
        this.setState({loading:false});
        this.setState({visible:false});
    }

    closeSpin=()=>{
        this.setState({loading:false});
    }

    beforeUpload = (file, fileList)=>{
        if(file.name.indexOf(".xlsx") == -1 && file.name.indexOf(".XLSX") == -1
            && file.name.indexOf(".xls") == -1 && file.name.indexOf(".XLS") == -1){
            message.error('只能上传Excel文件！');
            return false;
        }else{
            return true;
        }
    }
    onChange = (info)=>{
        let file = info.file;
        if(file.status == "done"){
            let response = file.response;
            if(response.code==200){
                this.setState({
                    resultObj:response.data
                });
            }
            if(file.response.code == "500") {
                const msg = response.message;
                message.error(msg.substring(msg.indexOf('[')+1),msg.substring(msg.indexOf(']')+1));
            }
        }else{
            let fileList = info.fileList;
            this.setState({fileList})
        }
    }
    handleOk = ()=>{
        let resultObj = this.state.resultObj;
        let titleData = this.props.data;
        if(resultObj && resultObj.length>0){
            if(titleData){
                for(let obj of resultObj){
                    for(let key in titleData){
                        let title = titleData[key];
                        if(obj[key]){
                            obj[title] = obj[key];
                        }
                    }
                }
            }
            this.setState({loading:true});
            this.props.onOk(resultObj);
        }else{
            message.warning("导入数据不能为空！");
        }
    }

    render(){
        let templateUrl = this.props.templateUrl?this.props.templateUrl:baseUrl+'/proData/getFileByName?fileRoot=excelTemp&fileName='+encodeURI(encodeURI(this.props.tempStr));
        const showUploadList={
            showDownloadIcon:false
        }
        const props = {
            name: 'file',
            // action: `http://ehall.kmust.edu.cn/skip/proData/operateExcelFile/`,
            action: `${pathUrl}/tjcx/hjblcx/operateExcelFile/`,
            beforeUpload: this.beforeUpload,
            onChange:this.onChange,
            showUploadList:showUploadList,
            accept:'.csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            // data :{uuid:this.state.uuid}
        };
        return <Modal /* key={this.props.key} */
            title={this.props.title}
            onCancel={this.close}
            okText={this.state.okText}
            onOk={this.handleOk}
            cancelText={this.state.cancelText}
            visible={this.state.visible}
            maskClosable={this.props.maskClosable}
            width={this.props.width?this.props.width:'1000px'}
        >
            <div>
                <Row style={{margin:'10px 0',padding:'5px 0'}}>
                    <Col>上传文件需要按照模板上传，如果还没有模板，可以先
                        <a href={templateUrl}
                           target={'_blank'}>
                            <Icon type="download" />下载模板</a>
                    </Col>
                </Row>
                <Row>
                    <Col span={6}>上传文件</Col>
                    <Col span={18}>
                        <Upload {...props} fileList={this.state.fileList} data={this.props.data}>
                            <Button>点击上传</Button>
                        </Upload>
                        <Spin tip="保存处理数据中。。。" spinning={this.state.loading}></Spin>
                    </Col>
                </Row>
            </div>
        </Modal>
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/hjblcx/import/index.js